/**
 * コントロールセクションのヘッダ factory。
 *
 * 設計書 10.2 / 10.4: 各コントロール群は `section-label`（英語大文字 +
 * モノスペース + 0.18em tracking）で始まる。本 factory は
 * `<div class="section"><div class="section-label">…</div></div>` を
 * 生成して、中身（子コントロール）を append していくためのコンテナを返す。
 *
 * 元は `src/main.ts` の `mountSectionHeading` として定義されていたが、
 * UI 層の責務として `src/ui/controls/` に移設した。
 */

/**
 * セクションヘッダ付きコンテナを生成して root に append する。
 *
 * @param root - 親コンテナ（通常は `.controls`）
 * @param label - セクションラベル（例: `"Shape"` / `"Perimeter Text"`）
 * @returns 生成したセクション要素。以後の `mount*` 呼び出しはこれを root に渡す。
 */
export function createSection(root: HTMLElement, label: string): HTMLElement {
  const section = document.createElement('div');

  const heading = document.createElement('div');
  heading.className = 'section-label';
  heading.textContent = label;
  section.appendChild(heading);

  root.appendChild(section);
  return section;
}
